import {createRoot} from "react-dom/client";
import "./App.css";
import App from "./App.tsx";
import "./i18n";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {AuthProvider} from "@/app/identity-access-management/authentication/context/AuthContext.tsx";
import {ShoppingCartProvider} from "@/app/shop/features/shopping-cart/shopping-cart.context.tsx";

async function enableMocking() {
    if (import.meta.env.DEV) {
        const { isMswEnabled } = await import("./mocks/utils");
        if (isMswEnabled()) {
            const { worker } = await import("./mocks/browser");
            await worker.start({
                onUnhandledRequest: "bypass",
                serviceWorker: { url: "/mockServiceWorker.js" },
            });
        }
    }
}

await enableMocking();

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: { retry: false },
        mutations: { retry: false },
    },
});

root.render(
    // <StrictMode>
        <AuthProvider>
            <ShoppingCartProvider>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </ShoppingCartProvider>
        </AuthProvider>
    // </StrictMode>
);
